import './styles.scss'
import { ID_NAMES } from "../../env";
import { DEFAULT_COLORS } from '../../colors';

const chat = () => {

    const { bodyBackgroundColor } = DEFAULT_COLORS;

    const chat = document.createElement("div");
    chat.id = ID_NAMES.CHAT
    chat.style.backgroundColor = bodyBackgroundColor;
    chat.classList.add('hide');


    //ADD CHAT
    const layout = document.getElementById(ID_NAMES.LAYOUT)
    layout.append(chat)

}

export default chat